import React from "react";
import PropTypes from "prop-types";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "max-content",
  bgcolor: "background.paper",
  border: "2px solid",
  borderColor: "black_solid.60",
  boxShadow: 24,
  padding: "20px"
};

export default function StyledModal({
  label,
  title,
  titleObject,
  open,
  handleClose,
  ...props
}) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby={`modal-${label}`}
      aria-describedby={`modal-${label}`}
    >
      <Box sx={style}>
        {title ? 
          (<Typography variant="h2">
            {title}
          </Typography>)
          : titleObject}
        <Divider sx={{ margin: "10px 0 20px 0", backgroundColor: "black_solid.50" }} />
        {props.children}
      </Box>
    </Modal>
  );
}

StyledModal.propTypes = {
  label: PropTypes.string.isRequired,
  title: PropTypes.string,
  titleObject: PropTypes.object,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  children: PropTypes.node
};